import { getToken } from ".";
import { HttpException } from "../../models/exceptions";

export interface RunActivationPipelinesResult {
  results: Record<string, any>[];
  total_onboarding: number;
  total_with_pipeline: number;
  total_completed: number;
  total_blocked: number;
  total_failed: number;
  total_skipped: number;
  total_error: number;
}

export async function runActivationPipelines({
  notifySlackBlocked = false,
  notifySlackSuccess = false,
}: {
  notifySlackBlocked?: boolean;
  notifySlackSuccess?: boolean;
}): Promise<RunActivationPipelinesResult> {
  const token = await getToken();

  const params = new URLSearchParams();
  params.append("notify_slack_blocked", notifySlackBlocked.toString());
  params.append("notify_slack_success", notifySlackSuccess.toString());

  const url = `${(window as any)._env_.REACT_APP_API_HOST}/admin/integrations/run-activation-pipelines?${params.toString()}`;

  const response = await fetch(url, {
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    const error = new HttpException(
      "An error occurred while running activation pipelines."
    );
    error.code = response.status;
    error.info = await response.json();
    throw error;
  }

  return response.json();
}
